import { useManagedArtistIds } from "@hooks/trpc/useManagedArtists";

const useIsArtistManager = (): boolean => {
  const managedArtistIds = useManagedArtistIds();

  return managedArtistIds !== undefined && managedArtistIds.length > 0;
};

export default useIsArtistManager;
